import React from 'react';
import BrandRedistributionFilter from './BrandRedistributionFilter';
import { Column } from '@ydistri/ds';
import OutOfStockSKUFilter from './OutOfStockSKUFilter';
import ForcedRedistributionFilter from './ForcedRedistributionFilter';
import SourceSkuClassFilter from './SourceSkuClassFilter';
import TargetSkuClassFilter from './TargetSkuClassFilter';

/**
 * All filters for the calculation's redistribution and their reset button.
 * aligned vertically. Used as a content for a dialog or popover.
 */
const CalculationRedistributionFilters: React.FC = () => {
  return (
    <Column $alignItems="flex-start" $gap="1rem">
      <BrandRedistributionFilter />
      <SourceSkuClassFilter />
      <TargetSkuClassFilter />
      <OutOfStockSKUFilter />
      <ForcedRedistributionFilter />
    </Column>
  );
};

export default CalculationRedistributionFilters;
